import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["buttons", "status", "reasons"];

  async rate(event) {
    const rating = event.currentTarget.dataset.rating;
    const ok = await this.post({ rating });
    if (!ok) return;

    this.buttonsTarget.classList.add("d-none");
    // Thumbs-down gets a one-tap follow-up asking why; the rating is
    // already saved, so bailing here still counts the thumbs-down.
    if (rating === "-1" && this.hasReasonsTarget) {
      this.reasonsTarget.classList.remove("d-none");
    } else {
      this.showThanks();
    }
  }

  async reason(event) {
    const reason = event.currentTarget.dataset.reason;
    await this.post({ rating: "-1", reason });
    this.reasonsTarget.classList.add("d-none");
    this.showThanks();
  }

  showThanks() {
    this.statusTarget.textContent = "Thanks for the feedback!";
    this.statusTarget.classList.remove("d-none");
  }

  async post(params) {
    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content;
      const response = await fetch("/discover/rate_results", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "X-CSRF-Token": token,
        },
        body: new URLSearchParams(params).toString(),
      });
      return response.ok;
    } catch {
      // Silently fail — feedback is best-effort
      return false;
    }
  }
}
